<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат Mobile Vertical Video</div>
    <div class="markup__h markup__h_3">
      <strong>Описание работы формата Mobile Vertical Video:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>При просмотре страницы на мобильном устройстве в вертикальной ориентации внутри статьи появляется плеер</li>
      <li>При доскролле до 50% видимости плеера стартует ролик со звуком и плеер разворачивается автоматически под размер экрана телефона</li>
      <li>При видимости плеера менее 50% ролик встает на паузу</li>
      <li>Переход происходит при клике на кнопку "перейти на сайт", текст можно менять</li>
      <li>Плеер можно пролистнуть и продолжить чтение статьи</li>
    </ul>
    <router-link to="/mobile/verticalVideo" target="_blank" class="link">Демо формата</router-link>
    <br><br>

    <div class="markup__h markup__h_3">
      <strong>Технические требования к видеоролику:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>Формат: MP4, MOV</li>
      <li>Видеокодек: H.264</li>
      <li>Аудиокодек: MP3 или AAC</li>
      <li>Разрешение: рекомендуется не ниже Full HD 1080p в вертикальном формате</li>
      <li>Частота кадров: 30 в секунду</li>
      <li>Соотношение сторон: максимально приближенное к 9:16</li>
      <li>Вес: ограничений нет, но рекомендуется до 3 МБ</li>
      <li>
        Хронометраж:
        <ul class="markup__ul markup__ul_nested">
          <li>оптимальный: 10-15 секунд</li>
          <li>максимальный: 30 секунд</li>
        </ul>
      </li>
    </ul>

    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'mobileVerticalVideo',
  components: {
    markedZoneAtention,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
